import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUnderline = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 640 640",
		fill: "currentColor",
		...props,
		children: /* @__PURE__ */ _jsx("path", { d: "M152 64C138.7 64 128 74.7 128 88C128 101.3 138.7 112 152 112L168 112L168 296C168 379.9 236.1 448 320 448C403.9 448 472 379.9 472 296L472 112L488 112C501.3 112 512 101.3 512 88C512 74.7 501.3 64 488 64L408 64C394.7 64 384 74.7 384 88C384 101.3 394.7 112 408 112L424 112L424 296C424 353.4 377.4 400 320 400C262.6 400 216 353.4 216 296L216 112L232 112C245.3 112 256 101.3 256 88C256 74.7 245.3 64 232 64L152 64zM128 552C128 565.3 138.7 576 152 576L488 576C501.3 576 512 565.3 512 552C512 538.7 501.3 528 488 528L152 528C138.7 528 128 538.7 128 552z" })
	});
};
export default SvgUnderline;
